import React, { memo } from 'react';
import ErrorBoundary from './tailwind/ErrorBoundary';

export const ProductPromoBar = ({ autoApplyDiscount }) =>
  autoApplyDiscount && (
    <ErrorBoundary
      inlineError
      message={
        <>
          Oops! Something went wrong while loading the promo bar.
          <br />
          <br />
          We're working hard to fix it. Please try again shortly.
        </>
      }>
      <div className={`promo-bar promo-bar-${autoApplyDiscount.code}`}>
        <div className='discount'>
          {autoApplyDiscount.fullDescription}
          {autoApplyDiscount.fullTerms && <sup>*</sup>}
        </div>
        <div className='terms'>
          {autoApplyDiscount.fullTerms && (
            <span>
              <sup>*</sup>
              {autoApplyDiscount.fullTerms}
            </span>
          )}
          {autoApplyDiscount.expirationDateFormattedFull && (
            <>
              <br />
              Offer Ends {autoApplyDiscount.expirationDateFormattedFull}
            </>
          )}
        </div>
      </div>
    </ErrorBoundary>
  );

export default memo(ProductPromoBar);
